// extracted by mini-css-extract-plugin
export default {"root":"Plans_root__-RnNo","planTable":"Plans_planTable__aG4rP","addButton":"Plans_addButton__ITjwn"};